import React, { useState } from 'react';
import MDButton from 'components/MDButton';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import { useAppServices } from 'hook/services';

const EditModal = ({ data, handleRefresh }) => {
  console.log(data, "data")
  const AppService = useAppServices();
  const [openEditProduct, setOpenEditProduct] = useState(false);
  const [processing, setProcessing] = useState(false);


  const handleModal = () => {
    setOpenEditProduct(true);
  };

  const closeEditProduct = () => {
    setOpenEditProduct(false);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);

    const payload = {
      name: e.target.name.value,

    };

    console.log(payload, "payload");

    const { response } = await AppService.servicecategory.update({
      query: `id=${data._id}`,
      payload,
    });

    if (response) {
      setProcessing(false);
      setOpenEditProduct(false);
      handleRefresh();
    }
  };


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style} encType="multipart/form-data">
            <MDTypography variant="h5" mb={2}>
              Edit Category
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required defaultValue={data.name} />
            </MDBox>



            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  );
};

export default EditModal;
